import React from "react";
import styled from "styled-components";

import { CircularProgress } from "@mui/material";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
`;

function Loader({addedStyles = {}}) {
  return (
    <Root style={addedStyles}>
      <CircularProgress m={2} color="secondary" />
    </Root>
  );
}

export default Loader;
